import React from "react";
import Layout from "@hoc/layouts/Layout";
import ProductForm from "@components/Product/ProductForm";

const ProductPage = () => {

  return (
    <Layout>
      <div className="mx-auto lg:mt-24 lg:mx-20 lg:mb-20 px-3">
        <ProductForm/>
      </div>
    </Layout>
  );
}

export default ProductPage;
